import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=73925e28&scoped=true"
import script from "./ContactList.vue?vue&type=script&lang=ts"
export * from "./ContactList.vue?vue&type=script&lang=ts"
import style0 from "./ContactList.vue?vue&type=style&index=0&id=73925e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73925e28",
  null
  
)

export default component.exports